import { Loader } from "@/layouts/signed-in/Loader/Loader";
import { DynamicSubmissionDetail } from "@/layouts/signed-in/views/SingleLocation/SubmissionsTab/children/DynamicSubmissionDetail";
import { useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const SubmissionDetail = () => {
	const { submissionId } = useParams<{ submissionId: string }>();
	const location = useLocation();
	const navigate = useNavigate();

	const toggleSubmission = useCallback(() => {
		// Check both the pathname and the state to determine if we're in admin view
		const isAdminView =
			location.pathname.includes("admin") || location?.state?.isAdminView;
		const locId = location?.state?.locationId || "";

		// Navigate back to the appropriate view with a refresh parameter
		navigate(
			isAdminView
				? `/admin/submissions?refresh=${Date.now()}`
				: `/locations/${locId}/submissions?refresh=${Date.now()}`,
			{
				state: {
					submissionsTableParams: {
						...location?.state?.submissionsTableParams,
						selectedForm: location?.state?.formId,
					},
					isAdminView, // Preserve the admin view state
				},
			},
		);
	}, [
		location.pathname,
		location?.state?.locationId,
		location?.state?.submissionsTableParams,
		location?.state?.formId,
		location?.state?.isAdminView,
		navigate,
	]);

	if (!submissionId) {
		return <Loader />;
	}

	// Render the appropriate submission component based on the organization
	const renderSubmissionComponent = () => {
		return (
			<DynamicSubmissionDetail
				submissionId={submissionId}
				formId={location.state?.formId || 3}
				toggleSubmission={toggleSubmission}
			/>
		);
	};

	return <div>{renderSubmissionComponent()}</div>;
};

export { SubmissionDetail };
